import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';

interface Props {
  open: boolean;
  onClose: () => void;
  onDeleteRedCard: () => void;
  onDeleteSubstitution: () => void;
}

const DeleteDialog: React.FunctionComponent<Props> = ({ open, onClose, onDeleteRedCard, onDeleteSubstitution }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">Delete</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Do you want to delete the substitution or the red card/injury
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button color="primary" autoFocus onClick={onDeleteRedCard}>
          Red card/injury
        </Button>
        <Button color="primary" autoFocus onClick={onDeleteSubstitution}>
          Substitution
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
